import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const BranchFilter = () => {
	const {
		branchButtonActive,
		setBranchButtonActive,
		branchButtonId,
		setBranchButtonId,
		setActivityString,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	const branchFilterHandler = (event) => {
		if (branchButtonId === "") {
			setActivityString(event.target.value);
			setBranchButtonId(event.target.id);
			setBranchButtonActive(true);
		} else if (branchButtonId !== event.target.id) {
			setActivityString(event.target.value);
			setBranchButtonId(event.target.id);
			setBranchButtonActive(true);
		} else if (branchButtonId === event.target.id) {
			setActivityString('AND terms.label:"Sportactiviteit"');
			setBranchButtonId("");
			setBranchButtonActive(false);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.discipline}</h3>
			<div>
				<button
					id="atletiek_wandelen_fietsen"
					value='AND (terms.label:"Atletiek, wandelen en fietsen") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive &&
						branchButtonId === "atletiek_wandelen_fietsen"
							? "active"
							: ""
					}
				>
					{dictionaryWords.athleticsWalkingCycling}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="bal_racketsport"
					value='AND (terms.label:"Bal en racketsport") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive &&
						branchButtonId === "bal_racketsport"
							? "active"
							: ""
					}
				>
					{dictionaryWords.ballRacketSports}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="fitness_gym_dans_vecht"
					value='AND (terms.label:"Fitness, gymnastiek, dans en vechtsport") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive &&
						branchButtonId === "fitness_gym_dans_vecht"
							? "active"
							: ""
					}
				>
					{dictionaryWords.fitnessGymDanceFighting}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="outdoor_adventure"
					value='AND (terms.label:"Outdoor en adventure") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive &&
						branchButtonId === "outdoor_adventure"
							? "active"
							: ""
					}
				>
					{dictionaryWords.outdoorAdventure}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="omnisport"
					value='AND (terms.label:"Omnisport en andere") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive && branchButtonId === "omnisport"
							? "active"
							: ""
					}
				>
					{dictionaryWords.omnisport}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="volkssporten"
					value='AND (terms.label:"Volkssporten") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive && branchButtonId === "volkssporten"
							? "active"
							: ""
					}
				>
					{dictionaryWords.folkSports}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="zwemmen_watersport"
					value='AND (terms.label:"Zwemmen en watersport") AND terms.label:"Sportactiviteit"'
					onClick={branchFilterHandler}
					className={
						branchButtonActive &&
						branchButtonId === "zwemmen_watersport"
							? "active"
							: ""
					}
				>
					{dictionaryWords.swimming}
					<i className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default BranchFilter;
